import { render } from "./product-reviews.vue?vue&type=template&id=f59fb134"
import script from "./product-reviews.vue?vue&type=script&lang=js"
export * from "./product-reviews.vue?vue&type=script&lang=js"

import "./product-reviews.vue?vue&type=style&index=0&id=f59fb134&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__